import { ResponseResult } from "../Common/Models/ResponseResult";

export default class ResponseHandler {
  static handle = async (
    response: Response,
    success: ((result: ResponseResult) => void) | null,
    error?: ((result: ResponseResult) => void) | null,
    fatal?: (() => any) | null
  ) => {
    await response
      .json()
      .then((result: ResponseResult) => {
        if (response.ok) {
          if (success) {
            success(result);
          }
        } else if (error) {
          error(result);
        }
      })
      .catch((err: Error) => {
        if (err) {
          throw err;
        } else if (fatal) {
          fatal();
        }
      });
  };
}
